import React, {useState} from "react"
import Typography from "../Typography/Typography"
import AccordionAnimation from "./AnimationComponent/AccordionAnimation"
import PlusDash from "../PlusDash"

interface Props {
    t: (arg0: string) => string,
    children: React.ReactChildren | React.ReactChild,
    label: string,
	titleClasses?: string
}

const ToggleItem:React.FC<Props> = ({t, children, label, titleClasses = ""}) => {
	const [showToggle, setShowToggle] = useState(false)
	return (
		<li
			className={"px-2 ps-md-3 mb-4 mb-md-5  pointer"}
			style={{borderLeft: showToggle ? "4px solid #FEC04D" : "4px solid #DEE2E6"}}
		>
			<span className="row g-2 d-flex g-md-3 align-items-center">
				<div className="col-12 overflow-hidden">
					<div className="cursor-pointer d-flex justify-content-between align-items-start"
						onClick={() => setShowToggle(!showToggle)}>
						{/* Check bold for mobile and desktop!!!! */}
						<Typography variant="bodyLgBold"
							className={`${titleClasses ? titleClasses : "text-bold ms-2"}`}
							semanticTag="h3">{t(label)}
						</Typography>
						<div className="col-1 pt-2 d-flex align-items-center justify-content-end">
							<PlusDash isOpen={showToggle}/>
						</div>
					</div>
					<AccordionAnimation inProp={showToggle}
						duration={400}
						transTimingFn="ease-out">
						{children}
					</AccordionAnimation>
				</div>
			</span>
		</li>
	)
}

export default ToggleItem
